import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import imageBanner from './img/imagem_banner_aulas.png';
import { Button } from '@/components/ui/button';
import { ModalSuccess, ModalSuccessBody, ModalSuccessContainer, ModalSuccessContent, ModalSuccessHeader, ModalSuccessImg, ModalSuccessName, ModalSuccessText } from '@/components/custom/modal';

export function CourseClassroomModalDisclaimer(props) {
  const { show, onClose, lessonName } = props;

  function closeOnEscapeKeyDown(event) {
    if (event.key === 'Escape') onClose();
  }

  useEffect(() => {
    document.body.addEventListener('keydown', closeOnEscapeKeyDown);

    return () => {
      document.body.removeEventListener('keydown', closeOnEscapeKeyDown);
      document.body.style.overflow = 'visible';
    };
  }, []);

  useEffect(() => {
    if (show) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'visible';
  }, [show]);

  const nodeRef = React.useRef(null); //Fix react-transition-group

  return ReactDOM.createPortal(
    <CSSTransition
      in={show}
      unmountOnExit
      nodeRef={nodeRef}
      timeout={{ enter: 0, exit: 300 }}
    >
      <ModalSuccess
        isActive={show}
        onClick={onClose}
        ref={nodeRef}
      >
        <ModalSuccessContent
          isDisclaimer
          onClick={event => event.stopPropagation()}
        >
          <ModalSuccessImg
            src={imageBanner}
            alt=""
          />

          <ModalSuccessContainer>
            <ModalSuccessHeader>
              <ModalSuccessName>Bem vindo à aula:</ModalSuccessName>
            </ModalSuccessHeader>

            <ModalSuccessBody className="mb-0 flex flex-col gap-8">
              <ModalSuccessText>{lessonName}</ModalSuccessText>
              <ModalSuccessText className="rounded-sm border-2 border-solid border-[#442B8C] p-8">
                <b>Atenção:</b> Para finalizar a aula, assista ao vídeo completo e responda às perguntas que surgirem.
              </ModalSuccessText>

              <Button
                wide
                onClick={onClose}
              >
                Começar a aula
              </Button>
            </ModalSuccessBody>
          </ModalSuccessContainer>
        </ModalSuccessContent>
      </ModalSuccess>
    </CSSTransition>,
    document.getElementById('modal_root')
  );
}
